module.exports = __webpack_public_path__ + "img/Tunisia.7c272c49.png";